module.exports = __webpack_public_path__ + "img/12.7c54d7d1.png";